import GatewayLogsTable from "./GatewayLogsTable"
import BeaconDataTable from "./BeaconDataTable"
import Typography from "@material-ui/core/Typography";

const Logs = () => {
   return (
    <>
    <Typography variant={"h6"} style={{ color: "#07689f", fontSize: '24px', fontWeight: 'bold' }} noWrap>
          Beacons Data
        </Typography>
    <BeaconDataTable/>
    <Typography variant={"h6"} style={{ color: "#07689f", fontSize: '24px', fontWeight: 'bold' }} noWrap>
          Gateway Data 
        </Typography>
    <GatewayLogsTable/>
    </>
   )
}

export default Logs